export const CUSTOM_METRICS_NAME = 'Custom Metrics';
//# sourceMappingURL=MetricSelectorColumn.constants.js.map